import { render, staticRenderFns } from "./regular_capacity.vue?vue&type=template&id=176c4e4e&"
import script from "./regular_capacity.vue?vue&type=script&lang=js&"
export * from "./regular_capacity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports